import { createFileRoute, redirect } from '@tanstack/react-router'
import { EmployeeOnboarding } from '@/features/hr-employees/onboarding/employee-onboarding'
import {
  type OnboardingStepId,
  parseOnboardingStep,
} from '@/features/hr-employees/onboarding/onboarding-steps'
import { hasGrant } from '@/lib/me'

export type OnboardingSearch = { step?: OnboardingStepId }

/**
 * Route shell for finishing an employee's setup (f442). "Finish setup" on the
 * profile opens it without `?step=`, and the wizard starts at the first step
 * that is not done; a Review link names its step. Anything else is dropped.
 * A child of the employee route, which renders its Outlet for it.
 */
export const Route = createFileRoute('/_authenticated/hr/employees/$employeeId/onboarding')({
  beforeLoad: ({ context, params }) => {
    if (!hasGrant(context.queryClient, 'employee.edit')) {
      throw redirect({ to: '/hr/employees/$employeeId', params: { employeeId: params.employeeId } })
    }
  },
  validateSearch: (search: Record<string, unknown>): OnboardingSearch => ({
    step: parseOnboardingStep(search.step),
  }),
  component: EmployeeOnboardingRoute,
})

function EmployeeOnboardingRoute() {
  const { employeeId } = Route.useParams()
  const { step } = Route.useSearch()

  return <EmployeeOnboarding employeeId={employeeId} step={step} />
}
